import Table from '../../../components/common/Table'
import Button from '../../../components/common/Button'

interface Message {
  id: number
  name: string
  email: string
  subject: string
  message: string
  is_read: boolean
  is_processed: boolean
  ip_address?: string
  created_at: string
}

interface MessageTableProps {
  messages: Message[]
  onView: (message: Message) => void
  onMarkAsRead: (messageId: number) => void
  onDelete: (messageId: number) => void
}

function MessageTable({ messages, onView, onMarkAsRead, onDelete }: MessageTableProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date)
  }

  const columns = [
    {
      key: 'status',
      label: 'Statut',
      render: (message: Message) => (
        <div className="message-status">
          {!message.is_read && (
            <span className="status-badge status-unread">Non lu</span>
          )}
          {message.is_read && !message.is_processed && (
            <span className="status-badge status-read">Lu</span>
          )}
          {message.is_processed && (
            <span className="status-badge status-processed">Traité</span>
          )}
        </div>
      ),
    },
    {
      key: 'name',
      label: 'Nom',
      render: (message: Message) => (
        <div className={`message-name ${!message.is_read ? 'unread-text' : ''}`}>
          {message.name}
        </div>
      ),
    },
    {
      key: 'email',
      label: 'Email',
      render: (message: Message) => (
        <a href={`mailto:${message.email}`} className="message-email">
          {message.email}
        </a>
      ),
    },
    {
      key: 'subject',
      label: 'Sujet',
      render: (message: Message) => (
        <div className={`message-subject ${!message.is_read ? 'unread-text' : ''}`}>
          {message.subject}
        </div>
      ),
    },
    {
      key: 'created_at',
      label: 'Date',
      render: (message: Message) => (
        <span className="message-date">{formatDate(message.created_at)}</span>
      ),
    },
  ]

  const actions = (message: Message) => (
    <>
      <Button
        variant="primary"
        size="small"
        onClick={() => onView(message)}
      >
        Voir
      </Button>
      {!message.is_read && (
        <Button
          variant="outline"
          size="small"
          onClick={(e) => {
            e.stopPropagation()
            onMarkAsRead(message.id)
          }}
        >
          Marquer lu
        </Button>
      )}
      <Button
        variant="secondary"
        size="small"
        onClick={(e) => {
          e.stopPropagation()
          onDelete(message.id)
        }}
      >
        Supprimer
      </Button>
    </>
  )

  return <Table data={messages} columns={columns} actions={actions} />
}

export default MessageTable
